import { getEnvRequired } from '../../shared/utilities/env';

import { DossierId } from '../dossier/types';
import { ApiClient } from '../shared/api/client';

import { serializePreTripReviewsFromAPI } from './serializers';
import { PreTripReviewsJSONAPIResponse } from './types';

const REQUEST_MANAGER_API_URL = getEnvRequired('REQUEST_MANAGER_API_URL');

const apiClient = new ApiClient(true);

export async function fetchPreTripReviews() {
    const url = `${REQUEST_MANAGER_API_URL}/pre-trip-review/list`;

    const response = await apiClient.get<PreTripReviewsJSONAPIResponse>(url);
    return serializePreTripReviewsFromAPI(response);
}

export async function patchRemovePreTripReview(dossierId: DossierId) {
    const url = `${REQUEST_MANAGER_API_URL}/pre-trip-review/acknowledge/${dossierId}`;
    await apiClient.patch(url);
}
